import { FlagListModel } from 'src/app/shared/components/flag-input/flag-input.model';
import { Phone } from '../models/phone.model';

export const flagOptions: FlagListModel[] = [
  {
    prefix: '+55',
    country: 'Brasil',
    icon: 'flag_br_ico',
    mask: '(00) 00000-0000',
    pattern: ['(00) 00000-0000', '(00) 0000-0000'],
    mask_length: 15,
    minimum_length: 10
  },
  {
    prefix: '+1',
    country: 'USA',
    icon: 'usa_flag_ico',
    mask: '(000) 000-0000',
    pattern: ['(000) 000-0000'],
    mask_length: 14,
    minimum_length: 10
  },
  {
    prefix: '+351',
    country: 'Portugal',
    icon: 'portugal_flag_ico',
    mask: '000 000 000',
    pattern: ['000 000 000'],
    mask_length: 11,
    minimum_length: 9
  }
];

export const isPhoneValid = (phone: Phone): boolean => {
  const phoneRegex = new RegExp('^([+][1-9]?[1-9]?[1-9]) ([0-9]?[0-9]?[0-9]) ([0-9][0-9][0-9][0-9]?[0-9]?) ([0-9][0-9][0-9][0-9]?)');
  if (!phoneRegex.test(`${phone.ddi} ${phone.phone}`)) {
    return true;
  }
  return false;
};

export const removeMask = (data) => {
  if (!data.phone) {
    return null;
  }
  data.phone = data.phone.replace(/[()]/g, '');
  data.phone = data.phone.replace(/-/g, ' ');
  return data;
};
